import { combineReducers } from 'redux';
import { usersFormReducer } from './usersFormReducer';
import { usersListReducer } from './usersListReducer';

export const usersReducer = combineReducers({
  usersForm: usersFormReducer,
  usersList: usersListReducer,
});
